import { InputChoice } from 'components/formInputs/types';
import range from 'utils/range';

import { HealthBasicsFormValues, HealthConditions } from './types';
import formatHeight from './utils/formatHeight';

export const HEIGHT_OPTIONS: Array<InputChoice<number>> = range(48, 84).map((value) => ({
  label: formatHeight(value),
  value,
}));

export const HEALTH_CONDITIONS_GROUP_LABEL =
  'Have you ever seen a doctor for or been diagnosed with any of the following conditions?';

export const HEALTH_CONDITION_LABELS: Record<HealthConditions, string> = {
  asthma: 'Asthma',
  backProblems: 'Back Problems',
  basalCellSkinCancer: 'Basal cell skin cancer',
  cancer: 'Cancer',
  carpalTunnel: 'Carpal tunnel syndrome',
  copd: 'COPD',
  depression: 'Depression',
  diabetes: 'Diabetes',
  emphysema: 'Emphysema',
  epilepsy: 'Epilepsy',
  glaucoma: 'Glaucoma',
  headachesOrMigraines: 'Frequent headaches or migraines',
  heartDisease: 'Heart disease',
  highBloodPressure: 'High blood pressure',
  highCholesterol: 'High cholesterol',
  kidneyOrLiverDisease: 'Kidney or liver disease',
  kneeInjuryOrSurgery: 'Knee injury or surgery',
  mentalIllness: 'Mental illness',
  otherSeriousMedicalConditions: 'Other serious medical conditions',
  rheumatoidArthritis: 'Rheumatoid arthritis',
  sleepApnea: 'Sleep apnea',
  stroke: 'Stroke',
  ulcerativeColitisOrIleitis: "Ulcerative colitis or crohn's disease",
  vascularDisease: 'Vascular disease',
  multipleSclerosis: 'Multiple Sclerosis',
  alzheimerDisease: "Alzheimer's Disease",
};

export const HEALTH_CONDITIONS = Object.keys(HEALTH_CONDITION_LABELS) as HealthConditions[];

export const HEALTH_CONDITIONS_OPTIONS = HEALTH_CONDITIONS.map((condition) => ({
  label: HEALTH_CONDITION_LABELS[condition],
  name: condition,
}));

export const LABELS: Record<keyof HealthBasicsFormValues, string> = {
  ...HEALTH_CONDITION_LABELS,
  heightInInches: 'Height',
  weight: 'Weight',
  historyOfTobaccoUse: 'Have you used any nicotine products in the last 5 years?',
  usedInPastYear: 'Have you used any tobacco product in the past 12 months?',
  planningToBeOrPregnant: 'Are you currently pregnant or trying to become pregnant?',
  suspendedConviction: 'Has your license been revoked or suspended in the last 10 years?',
  dwiConviction: 'Have you been convicted of drunk driving (DUI/DWI) in the last 10 years?',
  otherHealthIssues: 'Add any other health issues below',
};
